const en = {
    recipientReviewTitle: 'Recipient VAT source correction',
    recipientOriginal: 'Original statutory amounts',
    recipientCorrected: 'Corrected statutory amounts',
    recipientFiscalNet: 'Statutory net basis (EUR)',
    recipientOutputChange: 'Output VAT journal change (EUR)',
    recipientInputChange: 'Input VAT journal change (EUR)',
    recipientCostChange: 'Cost journal change (EUR)',
    recipientFixedHint: 'The original document-currency payable and book exchange rate stay fixed. Non-deductible recipient VAT changes the allocated expense or acquisition cost. These three signed journal changes form one balanced correction and include previous corrections.',
    vendorTitle: 'Supplier VAT evidence',
    vendorCurrency: 'VAT currency on the original',
    vendorDocument: 'Invoice currency',
    vendorEuro: 'EUR stated separately',
    vendorEvidence: 'Original evidence and legally owed VAT',
    vendorStated: 'VAT stated in EUR',
    vendorLegal: 'Legally owed VAT in EUR',
    vendorRate: 'Statutory VAT conversion source',
    vendorHint: 'No German input VAT may be deducted above the legally owed amount. Review the original invoice and retain the supporting evidence.',
    reviewReversal: 'Receipt reversal',
    reviewDiscount: 'Cash discount or its reversal',
    reviewTitle: 'Review existing VAT sources',
    reviewHint: 'Compare the original posting with reviewed statutory evidence. Corrections require the original tax period to be open. Original documents remain unchanged.',
    reviewAction: 'Review source',
    reviewReason: 'Reason and original evidence',
    reviewPreview: 'Calculate preview',
    reviewApprove: 'Approve and post correction',
    reviewRate: 'Applicable reviewed rate',
    reviewPosted: 'Previously posted VAT (EUR)',
    reviewFiscal: 'Documented VAT (EUR)',
    reviewDifference: 'Correction (EUR)',
    reviewSaved: 'Source review saved',
    reviewEmpty: 'No foreign-currency tax events found.',
    reviewError: 'The review could not be completed. Check the source evidence and whether the original tax period is open.',
    reviewDiscard: 'Discard changes',
    reviewKeep: 'Keep editing',
    reviewSearch: 'Find document',
    reviewPrevious: 'Previous',
    reviewNext: 'Next',
    reviewReceipt: 'Cash receipt',
    reviewSupply: 'Invoice',
    reviewVendor: 'Supplier invoice',
    reviewSupplier: 'Supplier',
    reviewEvidence: 'Original source evidence',
    reviewDeductible: 'Deductible input VAT (EUR)',
    vendorReviewEvidence: 'The immutable original VAT currency or deduction evidence is missing. Review the original supplier evidence before a statutory rate correction.',
    vendorReviewDependency: 'Reverse outstanding cash discounts or resolve linked credits before reviewing this source.',
    vendorReviewCancelled: 'This source has been cancelled or reversed; its original and reversal must stay balanced.',
    reviewRateDate: 'Statutory conversion date',
    reviewReportingDate: 'Original reporting date',
    vendorOriginalCurrency: 'Document-currency VAT must not include EUR tax buckets.',
    vendorEuroEvidence: 'Enter the actual EUR VAT shown on the original document.',
    vendorDuplicateRate: 'Each VAT rate may appear only once.',
    vendorLegalAmount: 'Legally owed VAT must be nonnegative and cannot exceed the stated VAT.',
    title: 'VAT conversion rates',
    hint: 'Review official monthly rates or daily rates permitted by your tax authority. Book and payment rates remain separate. Saved evidence is immutable; corrections create a new version.',
    add: 'Review and save rate',
    correct: 'Correct rate',
    cancel: 'Cancel correction',
    saved: 'Reviewed rate saved',
    empty: 'No reviewed VAT rates yet. Enter the official source below.',
    loading: 'Loading rates',
    retry: 'Retry',
    error: 'The rate could not be saved. Check the values and source evidence.',
    sourceCurrency: 'Foreign currency',
    method: 'Conversion policy',
    quoteDirection: 'Quote direction',
    quote: 'Original quoted value',
    validFrom: 'Valid from',
    validTo: 'Valid through',
    sourceUrl: 'Official source URL',
    sourceEvidence: 'Source evidence (exact published quote and context)',
    sourcePublishedOn: 'Source publication date',
    approvalReference: 'Tax authority permission reference',
    approvalEvidence: 'Permission evidence (authority, decision and scope)',
    approvalValidFrom: 'Permission valid from',
    approvalValidTo: 'Permission valid through',
    version: 'Version',
    reviewedAt: 'Reviewed on',
    MONTHLY_BMF: 'BMF monthly average',
    APPROVED_DAILY: 'Daily rate with tax authority permission',
    FOREIGN_PER_EUR: 'Foreign currency units per EUR',
    EUR_PER_FOREIGN: 'EUR per foreign currency unit',
    errors: {
        positiveQuote: 'Enter a positive quote.',
        dateRange: 'Check the validity dates.',
        month: 'A monthly rate must cover exactly one full calendar month.',
        officialSource: 'Use the official German Federal Ministry of Finance source.',
        policy: 'Monthly rates do not use daily permission fields.',
        day: 'A daily rate must cover exactly one day.',
        authorityApproval: 'Document the actual tax authority permission and its effective dates.',
        euroLedger: 'Statutory VAT conversion requires an EUR ledger.',
        stale: 'This version has already been corrected. Reload the list.',
        overlap: 'An approved rate already covers this currency and period.',
        ambiguous: 'Multiple fiscal rates apply. Accounting must review the sources.',
        missing: 'No reviewed fiscal rate covers this currency and tax date. Ask accounting to review the official source.',
    },
};
export const fiscalFxLabels = {
    en,
    de: {
        recipientReviewTitle: 'Quellenkorrektur der Empfängersteuer',
        recipientOriginal: 'Ursprüngliche gesetzliche Beträge',
        recipientCorrected: 'Korrigierte gesetzliche Beträge',
        recipientFiscalNet: 'Gesetzliche Nettobemessungsgrundlage (EUR)',
        recipientOutputChange: 'Buchungsänderung geschuldete Umsatzsteuer (EUR)',
        recipientInputChange: 'Buchungsänderung abziehbare Vorsteuer (EUR)',
        recipientCostChange: 'Buchungsänderung Kosten (EUR)',
        recipientFixedHint: 'Der ursprüngliche Zahlbetrag in Belegwährung und der Buchkurs bleiben fest. Nicht abziehbare Empfängersteuer ändert den zugeordneten Aufwand oder die Anschaffungskosten. Diese drei vorzeichenbehafteten Buchungsänderungen bilden eine ausgeglichene Korrektur und berücksichtigen bisherige Korrekturen.',
        vendorTitle: 'Steuernachweis der Lieferantenrechnung',
        vendorCurrency: 'Steuerwährung auf dem Original',
        vendorDocument: 'Rechnungswährung',
        vendorEuro: 'EUR gesondert ausgewiesen',
        vendorEvidence: 'Originalnachweis und gesetzlich geschuldete Steuer',
        vendorStated: 'Ausgewiesene Steuer in EUR',
        vendorLegal: 'Gesetzlich geschuldete Steuer in EUR',
        vendorRate: 'Gesetzliche Steuerumrechnung',
        vendorHint: 'Deutsche Vorsteuer darf den gesetzlich geschuldeten Betrag nicht übersteigen. Prüfen Sie die Originalrechnung und halten Sie den Nachweis fest.',
        reviewReversal: 'Zahlungsstorno',
        reviewDiscount: 'Skonto oder Skontostorno',
        reviewTitle: 'Bestehende Steuerquellen prüfen',
        reviewHint: 'Vergleichen Sie die ursprüngliche Buchung mit dem geprüften Steuernachweis. Für Korrekturen muss die ursprüngliche Steuerperiode geöffnet sein. Originalbelege bleiben unverändert.',
        reviewAction: 'Quelle prüfen',
        reviewReason: 'Begründung und Originalnachweis',
        reviewPreview: 'Vorschau berechnen',
        reviewApprove: 'Prüfung freigeben und Korrektur buchen',
        reviewRate: 'Anwendbarer geprüfter Kurs',
        reviewPosted: 'Bisher gebuchte Umsatzsteuer (EUR)',
        reviewFiscal: 'Nachgewiesene Umsatzsteuer (EUR)',
        reviewDifference: 'Korrektur (EUR)',
        reviewSaved: 'Quellenprüfung gespeichert',
        reviewEmpty: 'Keine Steuerereignisse in Fremdwährung gefunden.',
        reviewError: 'Die Prüfung konnte nicht abgeschlossen werden. Prüfen Sie den Originalnachweis und die Öffnung der ursprünglichen Steuerperiode.',
        reviewDiscard: 'Änderungen verwerfen',
        reviewKeep: 'Weiter bearbeiten',
        reviewSearch: 'Beleg suchen',
        reviewPrevious: 'Zurück',
        reviewNext: 'Weiter',
        reviewReceipt: 'Zahlungseingang',
        reviewSupply: 'Rechnung',
        reviewVendor: 'Lieferantenrechnung',
        reviewSupplier: 'Lieferant',
        reviewEvidence: 'Nachweis des Originals',
        reviewDeductible: 'Abziehbare Vorsteuer (EUR)',
        vendorReviewEvidence: 'Der unveränderliche Nachweis zur Steuerwährung oder zum Vorsteuerabzug fehlt. Prüfen Sie zuerst das Lieferantenoriginal.',
        vendorReviewDependency: 'Stornieren Sie offene Skontobuchungen oder klären Sie verknüpfte Gutschriften vor dieser Quellenprüfung.',
        vendorReviewCancelled: 'Diese Quelle wurde storniert. Original und Storno müssen ausgeglichen bleiben.',
        reviewRateDate: 'Gesetzlicher Umrechnungstag',
        reviewReportingDate: 'Ursprünglicher Meldetag',
        vendorOriginalCurrency: 'Steuer in Belegwährung darf keine EUR-Steuergruppen enthalten.',
        vendorEuroEvidence: 'Erfassen Sie die tatsächlich im Original ausgewiesene EUR-Umsatzsteuer.',
        vendorDuplicateRate: 'Jeder Steuersatz darf nur einmal vorkommen.',
        vendorLegalAmount: 'Gesetzlich geschuldete Steuer darf weder negativ noch höher als die ausgewiesene Steuer sein.',
        title: 'Umsatzsteuer-Umrechnungskurse',
        hint: 'Prüfen Sie amtliche Monatskurse oder vom Finanzamt gestattete Tageskurse. Buch- und Zahlungskurse bleiben getrennt. Gespeicherte Nachweise sind unveränderlich; Korrekturen erhalten eine neue Version.',
        add: 'Kurs prüfen und speichern',
        correct: 'Kurs korrigieren',
        cancel: 'Korrektur abbrechen',
        saved: 'Geprüfter Kurs gespeichert',
        empty: 'Noch keine geprüften Steuerkurse. Erfassen Sie unten die amtliche Quelle.',
        loading: 'Kurse werden geladen',
        retry: 'Erneut versuchen',
        error: 'Der Kurs konnte nicht gespeichert werden. Prüfen Sie Werte und Nachweise.',
        sourceCurrency: 'Fremdwährung',
        method: 'Umrechnungsverfahren',
        quoteDirection: 'Notierungsrichtung',
        quote: 'Originaler Kurswert',
        validFrom: 'Gültig ab',
        validTo: 'Gültig bis',
        sourceUrl: 'Amtliche Quellen-URL',
        sourceEvidence: 'Quellennachweis (veröffentlichter Kurs mit Kontext)',
        sourcePublishedOn: 'Veröffentlichungsdatum',
        approvalReference: 'Aktenzeichen der Finanzamtsgestattung',
        approvalEvidence: 'Gestattungsnachweis (Behörde, Entscheidung und Umfang)',
        approvalValidFrom: 'Gestattung gültig ab',
        approvalValidTo: 'Gestattung gültig bis',
        version: 'Version',
        reviewedAt: 'Geprüft am',
        MONTHLY_BMF: 'BMF-Monatsdurchschnitt',
        APPROVED_DAILY: 'Tageskurs mit Finanzamtsgestattung',
        FOREIGN_PER_EUR: 'Fremdwährungseinheiten je EUR',
        EUR_PER_FOREIGN: 'EUR je Fremdwährungseinheit',
        errors: {
            positiveQuote: 'Geben Sie einen positiven Kurs an.',
            dateRange: 'Prüfen Sie den Gültigkeitszeitraum.',
            month: 'Ein Monatskurs muss genau einen vollständigen Kalendermonat abdecken.',
            officialSource: 'Verwenden Sie die amtliche Quelle des Bundesfinanzministeriums.',
            policy: 'Monatskurse verwenden keine Tageskursgestattung.',
            day: 'Ein Tageskurs muss genau einen Tag abdecken.',
            authorityApproval: 'Dokumentieren Sie die tatsächliche Finanzamtsgestattung und deren Gültigkeit.',
            euroLedger: 'Die steuerliche Umrechnung benötigt ein EUR-Hauptbuch.',
            stale: 'Diese Version wurde bereits korrigiert. Laden Sie die Liste neu.',
            overlap: 'Ein geprüfter Kurs deckt diese Währung und diesen Zeitraum bereits ab.',
            ambiguous: 'Mehrere Steuerkurse passen. Die Buchhaltung muss die Nachweise prüfen.',
            missing: 'Für diese Währung und das Steuerdatum fehlt ein geprüfter Kurs. Lassen Sie die amtliche Quelle von der Buchhaltung prüfen.',
        },
    },
    fr: {
        recipientReviewTitle: 'Correction de la source de TVA autoliquidée',
        recipientOriginal: 'Montants légaux initiaux',
        recipientCorrected: 'Montants légaux corrigés',
        recipientFiscalNet: 'Base nette légale (EUR)',
        recipientOutputChange: 'Variation comptable de TVA due (EUR)',
        recipientInputChange: 'Variation comptable de TVA déductible (EUR)',
        recipientCostChange: 'Variation comptable du coût (EUR)',
        recipientFixedHint: 'La dette initiale en devise du document et le taux comptable restent fixes. La TVA autoliquidée non déductible modifie la charge ou le coût d’acquisition affecté. Ces trois variations comptables signées forment une correction équilibrée et tiennent compte des corrections antérieures.',
        vendorTitle: 'Justificatif de TVA fournisseur',
        vendorCurrency: 'Devise de la TVA sur l’original',
        vendorDocument: 'Devise de la facture',
        vendorEuro: 'EUR indiqué séparément',
        vendorEvidence: 'Justificatif original et TVA légalement due',
        vendorStated: 'TVA indiquée en EUR',
        vendorLegal: 'TVA légalement due en EUR',
        vendorRate: 'Conversion légale de la TVA',
        vendorHint: 'La TVA allemande déductible ne peut dépasser la TVA légalement due. Vérifiez la facture originale et conservez les justificatifs.',
        reviewReversal: 'Annulation d’encaissement',
        reviewDiscount: 'Escompte ou son annulation',
        reviewTitle: 'Vérifier les sources de TVA existantes',
        reviewHint: 'Comparez la comptabilisation initiale aux justificatifs fiscaux vérifiés. La période fiscale initiale doit être ouverte pour corriger. Les documents originaux restent inchangés.',
        reviewAction: 'Vérifier la source',
        reviewReason: 'Motif et justificatif original',
        reviewPreview: 'Calculer un aperçu',
        reviewApprove: 'Approuver et comptabiliser la correction',
        reviewRate: 'Taux vérifié applicable',
        reviewPosted: 'TVA déjà comptabilisée (EUR)',
        reviewFiscal: 'TVA justifiée (EUR)',
        reviewDifference: 'Correction (EUR)',
        reviewSaved: 'Vérification enregistrée',
        reviewEmpty: 'Aucun événement fiscal en devise trouvé.',
        reviewError: 'La vérification a échoué. Vérifiez le justificatif original et l’ouverture de la période fiscale initiale.',
        reviewDiscard: 'Abandonner les modifications',
        reviewKeep: 'Continuer la saisie',
        reviewSearch: 'Rechercher un document',
        reviewPrevious: 'Précédent',
        reviewNext: 'Suivant',
        reviewReceipt: 'Encaissement',
        reviewSupply: 'Facture',
        reviewVendor: 'Facture fournisseur',
        reviewSupplier: 'Fournisseur',
        reviewEvidence: 'Justificatif original',
        reviewDeductible: 'TVA déductible (EUR)',
        vendorReviewEvidence: 'La preuve figée de la devise de TVA ou du droit à déduction manque. Vérifiez d’abord la facture originale.',
        vendorReviewDependency: 'Annulez les escomptes en cours ou résolvez les avoirs liés avant cette révision.',
        vendorReviewCancelled: 'Cette source a été annulée. L’original et son annulation doivent rester équilibrés.',
        reviewRateDate: 'Date légale de conversion',
        reviewReportingDate: 'Date déclarative initiale',
        vendorOriginalCurrency: 'La TVA en devise du document ne doit pas inclure de groupes en EUR.',
        vendorEuroEvidence: 'Saisissez la TVA en EUR réellement indiquée sur le document original.',
        vendorDuplicateRate: 'Chaque taux de TVA ne peut apparaître qu’une fois.',
        vendorLegalAmount: 'La TVA légalement due doit être positive ou nulle et ne peut dépasser la TVA indiquée.',
        title: 'Taux de conversion de TVA',
        hint: 'Vérifiez les taux mensuels officiels ou les taux journaliers autorisés par le fisc. Les taux comptables et de paiement restent séparés. Les preuves enregistrées sont immuables ; les corrections créent une nouvelle version.',
        add: 'Vérifier et enregistrer',
        correct: 'Corriger le taux',
        cancel: 'Annuler la correction',
        saved: 'Taux vérifié enregistré',
        empty: 'Aucun taux fiscal vérifié. Saisissez la source officielle ci-dessous.',
        loading: 'Chargement des taux',
        retry: 'Réessayer',
        error: 'Impossible d’enregistrer le taux. Vérifiez les valeurs et les preuves.',
        sourceCurrency: 'Devise étrangère',
        method: 'Méthode de conversion',
        quoteDirection: 'Sens de cotation',
        quote: 'Valeur cotée originale',
        validFrom: 'Valable du',
        validTo: 'Valable jusqu’au',
        sourceUrl: 'URL de la source officielle',
        sourceEvidence: 'Preuve de source (cotation publiée et contexte)',
        sourcePublishedOn: 'Date de publication',
        approvalReference: 'Référence de l’autorisation fiscale',
        approvalEvidence: 'Preuve d’autorisation (autorité, décision et portée)',
        approvalValidFrom: 'Autorisation valable du',
        approvalValidTo: 'Autorisation valable jusqu’au',
        version: 'Version',
        reviewedAt: 'Vérifié le',
        MONTHLY_BMF: 'Moyenne mensuelle du BMF',
        APPROVED_DAILY: 'Taux journalier autorisé par le fisc',
        FOREIGN_PER_EUR: 'Unités de devise étrangère par EUR',
        EUR_PER_FOREIGN: 'EUR par unité de devise étrangère',
        errors: {
            positiveQuote: 'Saisissez un taux positif.',
            dateRange: 'Vérifiez les dates de validité.',
            month: 'Un taux mensuel doit couvrir un mois civil entier.',
            officialSource: 'Utilisez la source officielle du ministère fédéral allemand des Finances.',
            policy: 'Les taux mensuels n’utilisent pas les champs d’autorisation journalière.',
            day: 'Un taux journalier doit couvrir un seul jour.',
            authorityApproval: 'Documentez l’autorisation fiscale réelle et ses dates de validité.',
            euroLedger: 'La conversion fiscale exige un grand livre en EUR.',
            stale: 'Cette version a déjà été corrigée. Rechargez la liste.',
            overlap: 'Un taux vérifié couvre déjà cette devise et cette période.',
            ambiguous: 'Plusieurs taux fiscaux s’appliquent. La comptabilité doit vérifier les sources.',
            missing: 'Aucun taux fiscal vérifié ne couvre cette devise et cette date fiscale. Demandez à la comptabilité de vérifier la source officielle.',
        },
    },
    es: {
        recipientReviewTitle: 'Corrección de la fuente de IVA autorrepercutido',
        recipientOriginal: 'Importes legales originales',
        recipientCorrected: 'Importes legales corregidos',
        recipientFiscalNet: 'Base neta legal (EUR)',
        recipientOutputChange: 'Cambio contable del IVA devengado (EUR)',
        recipientInputChange: 'Cambio contable del IVA deducible (EUR)',
        recipientCostChange: 'Cambio contable del coste (EUR)',
        recipientFixedHint: 'La deuda original en la moneda del documento y el tipo contable permanecen fijos. El IVA autorrepercutido no deducible modifica el gasto o coste de adquisición asignado. Estos tres cambios contables con signo forman una corrección equilibrada y tienen en cuenta las correcciones anteriores.',
        vendorTitle: 'Justificante de IVA del proveedor',
        vendorCurrency: 'Moneda del IVA en el original',
        vendorDocument: 'Moneda de la factura',
        vendorEuro: 'EUR indicado por separado',
        vendorEvidence: 'Justificante original e IVA legalmente debido',
        vendorStated: 'IVA indicado en EUR',
        vendorLegal: 'IVA legalmente debido en EUR',
        vendorRate: 'Conversión legal del IVA',
        vendorHint: 'El IVA alemán deducible no puede superar el importe legalmente debido. Revise la factura original y conserve los justificantes.',
        reviewReversal: 'Anulación de cobro',
        reviewDiscount: 'Descuento por pronto pago o su anulación',
        reviewTitle: 'Revisar fuentes de IVA existentes',
        reviewHint: 'Compare el asiento original con la evidencia fiscal revisada. Las correcciones requieren que el período fiscal original esté abierto. Los documentos originales permanecen intactos.',
        reviewAction: 'Revisar fuente',
        reviewReason: 'Motivo y evidencia original',
        reviewPreview: 'Calcular vista previa',
        reviewApprove: 'Aprobar y contabilizar corrección',
        reviewRate: 'Tipo revisado aplicable',
        reviewPosted: 'IVA ya contabilizado (EUR)',
        reviewFiscal: 'IVA documentado (EUR)',
        reviewDifference: 'Corrección (EUR)',
        reviewSaved: 'Revisión guardada',
        reviewEmpty: 'No se encontraron hechos fiscales en moneda extranjera.',
        reviewError: 'No se pudo completar la revisión. Compruebe la evidencia original y la apertura del período fiscal original.',
        reviewDiscard: 'Descartar cambios',
        reviewKeep: 'Seguir editando',
        reviewSearch: 'Buscar documento',
        reviewPrevious: 'Anterior',
        reviewNext: 'Siguiente',
        reviewReceipt: 'Cobro',
        reviewSupply: 'Factura',
        reviewVendor: 'Factura de proveedor',
        reviewSupplier: 'Proveedor',
        reviewEvidence: 'Justificante original',
        reviewDeductible: 'IVA deducible (EUR)',
        vendorReviewEvidence: 'Falta la prueba inmutable de la moneda del IVA o de la deducción. Revise primero el original del proveedor.',
        vendorReviewDependency: 'Anule los descuentos pendientes o resuelva los abonos vinculados antes de revisar esta fuente.',
        vendorReviewCancelled: 'Esta fuente está anulada. El original y su anulación deben seguir compensados.',
        reviewRateDate: 'Fecha legal de conversión',
        reviewReportingDate: 'Fecha original de declaración',
        vendorOriginalCurrency: 'El IVA en moneda del documento no debe incluir grupos de IVA en EUR.',
        vendorEuroEvidence: 'Introduzca el IVA en EUR que figura realmente en el documento original.',
        vendorDuplicateRate: 'Cada tipo de IVA solo puede aparecer una vez.',
        vendorLegalAmount: 'El IVA legalmente debido no puede ser negativo ni superar el IVA indicado.',
        title: 'Tipos de conversión del IVA',
        hint: 'Revise los tipos mensuales oficiales o los diarios autorizados por la autoridad fiscal. Los tipos contables y de pago se mantienen separados. Las pruebas guardadas son inmutables; las correcciones crean una versión nueva.',
        add: 'Revisar y guardar tipo',
        correct: 'Corregir tipo',
        cancel: 'Cancelar corrección',
        saved: 'Tipo revisado guardado',
        empty: 'Todavía no hay tipos fiscales revisados. Introduzca la fuente oficial abajo.',
        loading: 'Cargando tipos',
        retry: 'Reintentar',
        error: 'No se pudo guardar el tipo. Revise los valores y las pruebas.',
        sourceCurrency: 'Moneda extranjera',
        method: 'Método de conversión',
        quoteDirection: 'Sentido de cotización',
        quote: 'Valor original cotizado',
        validFrom: 'Válido desde',
        validTo: 'Válido hasta',
        sourceUrl: 'URL de la fuente oficial',
        sourceEvidence: 'Prueba de fuente (cotización publicada y contexto)',
        sourcePublishedOn: 'Fecha de publicación',
        approvalReference: 'Referencia del permiso fiscal',
        approvalEvidence: 'Prueba del permiso (autoridad, decisión y alcance)',
        approvalValidFrom: 'Permiso válido desde',
        approvalValidTo: 'Permiso válido hasta',
        version: 'Versión',
        reviewedAt: 'Revisado el',
        MONTHLY_BMF: 'Media mensual del BMF',
        APPROVED_DAILY: 'Tipo diario con permiso fiscal',
        FOREIGN_PER_EUR: 'Unidades de moneda extranjera por EUR',
        EUR_PER_FOREIGN: 'EUR por unidad de moneda extranjera',
        errors: {
            positiveQuote: 'Introduzca un tipo positivo.',
            dateRange: 'Revise las fechas de validez.',
            month: 'Un tipo mensual debe cubrir exactamente un mes natural completo.',
            officialSource: 'Utilice la fuente oficial del Ministerio Federal de Finanzas alemán.',
            policy: 'Los tipos mensuales no utilizan los campos de permiso diario.',
            day: 'Un tipo diario debe cubrir exactamente un día.',
            authorityApproval: 'Documente el permiso fiscal real y su vigencia.',
            euroLedger: 'La conversión fiscal requiere un libro mayor en EUR.',
            stale: 'Esta versión ya se corrigió. Recargue la lista.',
            overlap: 'Un tipo revisado ya cubre esta moneda y este período.',
            ambiguous: 'Se aplican varios tipos fiscales. Contabilidad debe revisar las fuentes.',
            missing: 'No existe un tipo fiscal revisado para esta moneda y fecha fiscal. Solicite a contabilidad la revisión de la fuente oficial.',
        },
    },
    tr: {
        recipientReviewTitle: 'Alıcı KDV kaynak düzeltmesi',
        recipientOriginal: 'İlk yasal tutarlar',
        recipientCorrected: 'Düzeltilmiş yasal tutarlar',
        recipientFiscalNet: 'Yasal net matrah (EUR)',
        recipientOutputChange: 'Ödenecek KDV kayıt değişikliği (EUR)',
        recipientInputChange: 'İndirilecek KDV kayıt değişikliği (EUR)',
        recipientCostChange: 'Maliyet kayıt değişikliği (EUR)',
        recipientFixedHint: 'Belge para birimindeki ilk borç ve defter kuru sabit kalır. İndirilemeyen alıcı KDV, ayrılan gideri veya edinim maliyetini değiştirir. Bu üç işaretli kayıt değişikliği dengeli bir düzeltme oluşturur ve önceki düzeltmeleri içerir.',
        vendorTitle: 'Tedarikçi KDV belgesi',
        vendorCurrency: 'Orijinal belgede KDV para birimi',
        vendorDocument: 'Fatura para birimi',
        vendorEuro: 'Ayrıca belirtilen EUR',
        vendorEvidence: 'Orijinal belge ve yasal KDV tutarı',
        vendorStated: 'EUR olarak belirtilen KDV',
        vendorLegal: 'EUR olarak yasal KDV tutarı',
        vendorRate: 'Yasal KDV dönüşüm kaynağı',
        vendorHint: 'İndirilecek Alman KDV tutarı yasal olarak borçlu olunan tutarı aşamaz. Orijinal faturayı inceleyin ve dayanakları saklayın.',
        reviewReversal: 'Tahsilat iptali',
        reviewDiscount: 'Erken ödeme indirimi veya iptali',
        reviewTitle: 'Mevcut KDV kaynaklarını incele',
        reviewHint: 'İlk kaydı incelenmiş yasal vergi kanıtıyla karşılaştırın. Düzeltme için ilk vergi dönemi açık olmalıdır. Asıl belgeler değişmeden kalır.',
        reviewAction: 'Kaynağı incele',
        reviewReason: 'Gerekçe ve asıl kanıt',
        reviewPreview: 'Önizleme hesapla',
        reviewApprove: 'Onayla ve düzeltmeyi kaydet',
        reviewRate: 'Geçerli incelenmiş kur',
        reviewPosted: 'Önceden kaydedilen KDV (EUR)',
        reviewFiscal: 'Belgelenen KDV (EUR)',
        reviewDifference: 'Düzeltme (EUR)',
        reviewSaved: 'Kaynak incelemesi kaydedildi',
        reviewEmpty: 'Yabancı para vergi olayı bulunamadı.',
        reviewError: 'İnceleme tamamlanamadı. Asıl kanıtı ve ilk vergi döneminin açık olduğunu kontrol edin.',
        reviewDiscard: 'Değişiklikleri sil',
        reviewKeep: 'Düzenlemeye devam et',
        reviewSearch: 'Belge ara',
        reviewPrevious: 'Önceki',
        reviewNext: 'Sonraki',
        reviewReceipt: 'Tahsilat',
        reviewSupply: 'Fatura',
        reviewVendor: 'Tedarikçi faturası',
        reviewSupplier: 'Tedarikçi',
        reviewEvidence: 'Asıl belge kanıtı',
        reviewDeductible: 'İndirilebilir KDV (EUR)',
        vendorReviewEvidence: 'Vergi para birimi veya indirim hakkının değişmez kanıtı eksik. Önce tedarikçinin asıl belgesini inceleyin.',
        vendorReviewDependency: 'Bu kaynağı incelemeden önce açık iskontoları ters kaydedin veya bağlı alacak belgelerini çözümleyin.',
        vendorReviewCancelled: 'Bu kaynak iptal edilmiş. Asıl kayıt ve ters kayıt dengede kalmalıdır.',
        reviewRateDate: 'Yasal dönüştürme tarihi',
        reviewReportingDate: 'İlk bildirim tarihi',
        vendorOriginalCurrency: 'Belge para birimindeki KDV, EUR vergi grupları içermemelidir.',
        vendorEuroEvidence: 'Asıl belgede gerçekten gösterilen EUR KDV tutarını girin.',
        vendorDuplicateRate: 'Her KDV oranı yalnızca bir kez yer alabilir.',
        vendorLegalAmount: 'Yasal olarak borçlanılan KDV negatif olamaz ve gösterilen KDV tutarını aşamaz.',
        title: 'KDV dönüşüm kurları',
        hint: 'Resmî aylık kurları veya vergi dairesinin izin verdiği günlük kurları inceleyin. Defter ve ödeme kurları ayrı tutulur. Kaydedilen kanıtlar değiştirilemez; düzeltmeler yeni sürüm oluşturur.',
        add: 'Kuru incele ve kaydet',
        correct: 'Kuru düzelt',
        cancel: 'Düzeltmeyi iptal et',
        saved: 'İncelenen kur kaydedildi',
        empty: 'Henüz incelenmiş vergi kuru yok. Aşağıya resmî kaynağı girin.',
        loading: 'Kurlar yükleniyor',
        retry: 'Yeniden dene',
        error: 'Kur kaydedilemedi. Değerleri ve kaynak kanıtlarını kontrol edin.',
        sourceCurrency: 'Yabancı para birimi',
        method: 'Dönüşüm yöntemi',
        quoteDirection: 'Kur yönü',
        quote: 'Yayımlanan özgün kur',
        validFrom: 'Geçerlilik başlangıcı',
        validTo: 'Geçerlilik bitişi',
        sourceUrl: 'Resmî kaynak URL’si',
        sourceEvidence: 'Kaynak kanıtı (yayımlanan kur ve bağlam)',
        sourcePublishedOn: 'Yayım tarihi',
        approvalReference: 'Vergi dairesi izin referansı',
        approvalEvidence: 'İzin kanıtı (kurum, karar ve kapsam)',
        approvalValidFrom: 'İzin başlangıcı',
        approvalValidTo: 'İzin bitişi',
        version: 'Sürüm',
        reviewedAt: 'İnceleme tarihi',
        MONTHLY_BMF: 'BMF aylık ortalaması',
        APPROVED_DAILY: 'Vergi dairesi izinli günlük kur',
        FOREIGN_PER_EUR: 'EUR başına yabancı para birimi',
        EUR_PER_FOREIGN: 'Yabancı para birimi başına EUR',
        errors: {
            positiveQuote: 'Pozitif bir kur girin.',
            dateRange: 'Geçerlilik tarihlerini kontrol edin.',
            month: 'Aylık kur tam bir takvim ayını kapsamalıdır.',
            officialSource: 'Alman Federal Maliye Bakanlığının resmî kaynağını kullanın.',
            policy: 'Aylık kurlar günlük izin alanlarını kullanmaz.',
            day: 'Günlük kur yalnızca bir günü kapsamalıdır.',
            authorityApproval: 'Gerçek vergi dairesi iznini ve geçerlilik tarihlerini belgeleyin.',
            euroLedger: 'Vergi dönüşümü EUR defteri gerektirir.',
            stale: 'Bu sürüm zaten düzeltildi. Listeyi yeniden yükleyin.',
            overlap: 'İncelenmiş bir kur bu para birimini ve dönemi zaten kapsıyor.',
            ambiguous: 'Birden fazla vergi kuru geçerli. Muhasebe kaynakları incelemelidir.',
            missing: 'Bu para birimi ve vergi tarihi için incelenmiş kur yok. Muhasebeden resmî kaynağı incelemesini isteyin.',
        },
    },
};
//# sourceMappingURL=fiscal-fx.js.map